import React from "react";

export default function useRemovePointerEvent(isOpen: boolean | undefined) {
    React.useEffect(() => {
        const removePointerEventsNone = () => {
            document.body.style.removeProperty("pointer-events");
        };

        removePointerEventsNone();

        if (!isOpen) {
            setTimeout(removePointerEventsNone, 0);
        }
    }, [isOpen]);

    const handleRemovePointerEvent = () => {
        const removePointerEventsNone = () => {
            document.body.style.removeProperty("pointer-events");
        };

        removePointerEventsNone();

        if (!isOpen) {
            setTimeout(removePointerEventsNone, 0);
        }
    };

    return { handleRemovePointerEvent };
}